import { render, staticRenderFns } from "./SkupTeme.vue?vue&type=template&id=65eadb34&scoped=true&"
import script from "./SkupTeme.vue?vue&type=script&lang=js&"
export * from "./SkupTeme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eadb34",
  null
  
)

export default component.exports